var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('a', {
    staticClass: "network_row",
    attrs: {
      "active": _vm.isSelected,
      "href": _vm.explorerFEUrl
    }
  }, [_vm.isSelected ? _c('img', {
    attrs: {
      "src": "img/ava_logo_".concat(_vm.logoColor, ".png")
    }
  }) : _c('img', {
    attrs: {
      "src": "img/ava_logo_black.png"
    }
  }), _c('div', {
    staticClass: "name_col"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.network.name))]), _c('p', {
    staticClass: "url"
  }, [_vm._v(_vm._s(_vm.endpoint))])]), _c('div', {
    staticClass: "status_col"
  }, [!_vm.isSelected ? _c('button', {
    on: {
      "click": _vm.select
    }
  }) : !_vm.isConnected ? _c('button', {
    staticClass: "connecting"
  }, [_vm._v(" Connecting... ")]) : _c('p', {
    staticClass: "connected"
  }, [_vm._v("Connected")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }